import { render, staticRenderFns } from "./list-favourites.vue?vue&type=template&id=4ae0e6f4&scoped=true&"
import script from "./list-favourites.vue?vue&type=script&lang=ts&"
export * from "./list-favourites.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae0e6f4",
  null
  
)

export default component.exports